import { SvgIcon, SvgIconProps } from "@mui/material";

export const PostIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "28", fill: "none" }}
      width="25"
      height="28"
      viewBox="0 0 25 28"
      fill="none"
    >
      <path d="M10.2126 25.8401L10.5389 28H18.89L17.9248 25.5928L10.2126 25.8401Z" fill="#111111" />
      <path
        d="M7.20342 9.50818C8.49682 9.50818 9.54533 8.45968 9.54533 7.16628C9.54533 5.87288 8.49682 4.82437 7.20342 4.82437C5.91002 4.82437 4.86151 5.87288 4.86151 7.16628C4.86151 8.45968 5.91002 9.50818 7.20342 9.50818Z"
        fill="#111111"
      />
      <path
        d="M16.8347 10.1847C16.8347 10.1847 18.2893 10.654 20.1128 12.9106C21.9364 15.1672 22.4221 16.6569 22.4221 16.6569L18.9795 17.1476L16.8347 10.1847Z"
        fill="#008B07"
      />
      <path
        opacity="0.46"
        d="M16.8347 10.1847C16.8347 10.1847 18.2893 10.654 20.1128 12.9106C21.9364 15.1672 22.4221 16.6569 22.4221 16.6569L18.9795 17.1476L16.8347 10.1847Z"
        fill="white"
      />
      <path
        d="M14.0437 5.59999C14.0437 5.59999 14.1692 6.57516 14.0374 7.23154C14.0244 7.29539 13.9989 7.35602 13.9623 7.40995C13.9258 7.46388 13.8789 7.51003 13.8244 7.54574C13.7699 7.58145 13.7089 7.606 13.6448 7.61799C13.5808 7.62998 13.515 7.62916 13.4513 7.61559C13.12 7.5428 12.6983 7.34826 12.5602 6.8337L12.2276 5.9878C12.1789 5.8114 12.186 5.62423 12.248 5.45205C12.3101 5.27988 12.424 5.13118 12.574 5.02643C13.1087 4.60599 13.9935 5.00133 14.0437 5.59999Z"
        fill="#F4A28C"
      />
      <path d="M12.2863 6.14342L11.9248 9.34878L13.7057 9.42157L13.2539 7.06085L12.2863 6.14342Z" fill="#F4A28C" />
      <path
        d="M13.8005 5.65146C13.4971 5.67769 13.1917 5.668 12.8906 5.6226C12.9846 5.75215 13.0387 5.90641 13.046 6.06633C13.0534 6.22625 13.0137 6.38482 12.932 6.52247C12.8553 6.65737 12.7342 6.76143 12.5893 6.81684C12.4443 6.87225 12.2847 6.87555 12.1376 6.82619L12.0961 5.56236C12.0841 5.38174 12.1212 5.20124 12.2034 5.03996C12.2856 4.87868 12.4098 4.74262 12.563 4.64617C12.6956 4.56198 12.8335 4.48652 12.9759 4.42027C13.3324 4.25837 13.877 4.47674 14.1921 4.21695C14.2238 4.19254 14.2612 4.17656 14.3007 4.1705C14.3403 4.16443 14.3808 4.16847 14.4183 4.18225C14.4559 4.19603 14.4894 4.2191 14.5157 4.24931C14.5419 4.27951 14.5601 4.31587 14.5686 4.355C14.6426 4.73152 14.6012 5.34398 14.0904 5.57742C13.9985 5.6178 13.9005 5.64281 13.8005 5.65146Z"
        fill="#707070"
      />
      <path
        d="M13.0393 6.48855C13.0393 6.48855 13.0142 6.11204 12.7318 6.1522C12.4495 6.19236 12.4808 6.74206 12.8686 6.77971L13.0393 6.48855Z"
        fill="#F4A28C"
      />
      <path
        d="M14.0921 6.21872L14.3832 6.5852C14.3998 6.60596 14.4109 6.6306 14.4154 6.65681C14.4198 6.68302 14.4176 6.70993 14.4088 6.73503C14.4 6.76012 14.385 6.78258 14.3652 6.80027C14.3453 6.81797 14.3213 6.83034 14.2954 6.83621L13.9189 6.92407L14.0921 6.21872Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M13.375 7.57291C13.153 7.52664 12.9494 7.41674 12.7888 7.25664C12.7888 7.25664 12.8416 7.844 13.5143 8.39622L13.375 7.57291Z"
        fill="#CE8172"
      />
      <path
        d="M6.86071 12.199C7.59491 10.216 10.7513 9.25342 12.8673 9.34002L13.6568 9.37265C13.6568 9.37265 19.2053 9.39399 19.5856 14.448C19.9659 19.5021 17.6478 23.4843 17.6478 23.4843L10.1916 23.6964C10.1916 23.6964 5.21535 16.6431 6.86071 12.199Z"
        fill="#008B07"
      />
      <path
        d="M17.671 9.32871C17.671 9.32871 17.1414 7.11355 16.7259 6.93784C16.3105 6.76214 16.7661 8.04479 16.7661 8.04479C16.7661 8.04479 16.052 7.2491 15.801 7.3131C15.55 7.37711 16.3795 8.43135 16.3795 8.43135C16.3795 8.43135 15.4897 9.08397 16.8979 9.6638L17.671 9.32871Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.06"
        d="M10.7599 12.2128C10.7599 12.2128 12.1743 12.7336 11.8405 15.0253C11.5066 17.3171 11.533 17.5894 11.533 17.5894L8.48199 18.0236L10.7599 12.2128Z"
        fill="#111111"
      />
      <path
        d="M22.8923 16.4975L17.8344 9.00113L16.543 9.56841C16.543 9.56841 18.2159 17.6459 21.7577 18.2935C22.7517 18.4742 23.4558 17.3384 22.8923 16.4975Z"
        fill="#008B07"
      />
      <path
        opacity="0.46"
        d="M22.8923 16.4975L17.8344 9.00113L16.543 9.56841C16.543 9.56841 18.2159 17.6459 21.7577 18.2935C22.7517 18.4742 23.4558 17.3384 22.8923 16.4975Z"
        fill="white"
      />
      <path
        d="M1.76001 12.386C1.76001 12.386 -0.75007 20.0267 3.63505 20.1133C7.21694 20.1836 10.5164 16.9757 10.8126 12.8566C10.9444 11.0117 8.72801 9.98133 7.42402 11.2928C6.9482 11.7702 6.63393 12.3847 6.52541 13.0499C6.24428 14.6476 7.01613 17.066 4.70058 17.3999C2.38503 17.7337 2.40511 12.3797 2.40511 12.3797L1.76001 12.386Z"
        fill="#008B07"
      />
      <path
        opacity="0.46"
        d="M1.76001 12.386C1.76001 12.386 -0.75007 20.0267 3.63505 20.1133C7.21694 20.1836 10.5164 16.9757 10.8126 12.8566C10.9444 11.0117 8.72801 9.98133 7.42402 11.2928C6.9482 11.7702 6.63393 12.3847 6.52541 13.0499C6.24428 14.6476 7.01613 17.066 4.70058 17.3999C2.38503 17.7337 2.40511 12.3797 2.40511 12.3797L1.76001 12.386Z"
        fill="white"
      />
      <path
        d="M0.725006 2.83263L4.24666 27.5419L24.1278 24.7093L20.6074 0L0.725006 2.83263ZM21.1822 16.2164L4.69094 18.5658L2.63518 4.1454L19.1264 1.79596L21.1822 16.2164Z"
        fill="#A0A0A0"
      />
      <path
        d="M6.87691 19.659C6.75955 19.675 6.65089 19.7298 6.56817 19.8146C6.49934 19.887 6.44558 19.9723 6.41003 20.0656C6.35044 19.9844 6.27538 19.9157 6.18915 19.8635C6.08727 19.8029 5.96767 19.7789 5.85028 19.7958C5.76984 19.8077 5.69265 19.8358 5.62338 19.8783C5.5541 19.9209 5.49419 19.9771 5.44726 20.0435C5.40033 20.1099 5.36736 20.1852 5.35035 20.2647C5.33333 20.3442 5.33262 20.4263 5.34827 20.5061C5.40098 20.8952 5.74988 21.1186 6.277 21.4575L6.57319 21.6495C6.58001 21.6544 6.58773 21.6579 6.59591 21.6599C6.6041 21.6618 6.61258 21.6621 6.62088 21.6608C6.6373 21.6584 6.65238 21.6504 6.66355 21.6382C6.74639 21.5428 6.82671 21.4524 6.89825 21.3734C7.31618 20.9065 7.59229 20.5978 7.53958 20.2099C7.53348 20.1298 7.51134 20.0517 7.47447 19.9802C7.4376 19.9088 7.38674 19.8455 7.32493 19.7941C7.26312 19.7427 7.19161 19.7043 7.11464 19.6811C7.03768 19.6578 6.95684 19.6503 6.87691 19.659Z"
        fill="white"
      />
      <path
        d="M7.64881 6.14091C7.51704 6.15854 7.39503 6.21999 7.30242 6.31536C7.22501 6.39756 7.16484 6.49443 7.12546 6.60025C7.0579 6.50844 6.97253 6.43118 6.87445 6.37309C6.76104 6.30618 6.62847 6.27922 6.49794 6.29653C6.12142 6.34674 5.88548 6.68936 5.9407 7.09348C5.99968 7.52898 6.39 7.77999 6.98113 8.16027L7.31371 8.37613C7.32896 8.38707 7.34789 8.39157 7.36643 8.38868C7.38547 8.38634 7.40294 8.37694 7.41537 8.36233C7.50825 8.25565 7.59861 8.15525 7.67768 8.06614C8.14706 7.54279 8.45706 7.1964 8.39807 6.7609C8.34285 6.35678 8.01905 6.09071 7.64881 6.14091Z"
        fill="white"
      />
      <path
        d="M10.199 20.6216C10.2811 20.5386 10.3433 20.4382 10.3811 20.3278C10.4189 20.2174 10.4313 20.0999 10.4174 19.984C10.3522 19.5309 9.86395 19.231 9.32679 19.3025C8.78963 19.3741 8.40559 19.8045 8.47085 20.2614C8.53611 20.7182 9.02307 21.0207 9.56148 20.9441C9.70537 20.9238 9.84393 20.8757 9.96937 20.8023L10.5542 21.1035L10.199 20.6216Z"
        fill="white"
      />
      <path d="M21.6975 20.7146L5.2966 23.0339L5.90279 27.3205L22.3037 25.0012L21.6975 20.7146Z" fill="#E7E7E7" />
      <path
        d="M1.57354 12.1024C1.48465 11.9562 1.44039 11.7872 1.44618 11.6162C1.45198 11.4452 1.50759 11.2796 1.60617 11.1397C1.73168 10.9766 1.89986 10.8737 2.13581 11.0054C2.66669 11.3004 2.56127 13.7866 1.57354 12.1024Z"
        fill="#F4A28C"
      />
      <path
        d="M18.7585 19.2047C18.9505 19.2047 19.1061 19.049 19.1061 18.857C19.1061 18.665 18.9505 18.5094 18.7585 18.5094C18.5665 18.5094 18.4108 18.665 18.4108 18.857C18.4108 19.049 18.5665 19.2047 18.7585 19.2047Z"
        fill="white"
      />
      <path
        d="M19.8186 19.0528C20.0106 19.0528 20.1663 18.8971 20.1663 18.7051C20.1663 18.5131 20.0106 18.3575 19.8186 18.3575C19.6266 18.3575 19.471 18.5131 19.471 18.7051C19.471 18.8971 19.6266 19.0528 19.8186 19.0528Z"
        fill="white"
      />
      <path
        d="M20.9082 18.8984C21.1002 18.8984 21.2559 18.7428 21.2559 18.5508C21.2559 18.3588 21.1002 18.2031 20.9082 18.2031C20.7162 18.2031 20.5606 18.3588 20.5606 18.5508C20.5606 18.7428 20.7162 18.8984 20.9082 18.8984Z"
        fill="white"
      />
      <path
        d="M11.1161 9.47556C11.1161 9.47556 11.0709 8.56314 12.1854 8.46273C13.2999 8.36233 14.4131 8.27573 14.5851 9.46677C14.5851 9.46426 13.517 10.0592 11.1161 9.47556Z"
        fill="#008B07"
      />
      <path
        opacity="0.46"
        d="M11.1161 9.47556C11.1161 9.47556 11.0709 8.56314 12.1854 8.46273C13.2999 8.36233 14.4131 8.27573 14.5851 9.46677C14.5851 9.46426 13.517 10.0592 11.1161 9.47556Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const ChallengeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "27", height: "28", fill: "none" }}
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
    >
      <path
        d="M20.4434 6.74225L21.8128 8.41774C21.8895 8.51155 21.9876 8.58559 22.0988 8.63365C22.21 8.68171 22.3311 8.70238 22.452 8.69392C22.5728 8.68547 22.6899 8.64813 22.7933 8.58506C22.8968 8.52198 22.9836 8.435 23.0464 8.33143L23.6736 7.3648L24.1891 7.7434C24.1891 7.7434 23.6863 9.1243 22.799 9.87113C21.9118 10.618 19.6747 8.23477 19.6747 8.23477L20.4434 6.74225Z"
        fill="#111111"
      />
      <path
        opacity="0.09"
        d="M20.4434 6.74225L21.8128 8.41774C21.8895 8.51155 21.9876 8.58559 22.0988 8.63365C22.21 8.68171 22.3311 8.70238 22.452 8.69392C22.5728 8.68547 22.6899 8.64813 22.7933 8.58506C22.8968 8.52198 22.9836 8.435 23.0464 8.33143L23.6736 7.3648L24.1891 7.7434C24.1891 7.7434 23.6863 9.1243 22.799 9.87113C21.9118 10.618 19.6747 8.23477 19.6747 8.23477L20.4434 6.74225Z"
        fill="#111111"
      />
      <path
        d="M20.6794 5.05293C20.6584 5.28917 20.6054 5.52145 20.5218 5.74338C20.4982 5.79461 20.4553 5.83441 20.4024 5.85404C20.3496 5.87367 20.2911 5.87153 20.2398 5.8481C20.1557 5.81522 20.0828 5.75875 20.0299 5.68547C19.977 5.61219 19.9464 5.52522 19.9418 5.43498L19.8819 5.04948C19.8783 4.97078 19.8991 4.89289 19.9416 4.82653C19.984 4.76017 20.046 4.7086 20.119 4.67893C20.3837 4.54775 20.7162 4.79401 20.6794 5.05293Z"
        fill="#F4A28C"
      />
      <path d="M19.8933 5.11392L19.4365 6.42118L20.1753 6.62141L20.2109 5.59033L19.8933 5.11392Z" fill="#F4A28C" />
      <path
        d="M20.6421 5.31761L20.7296 5.49828C20.7347 5.50847 20.7371 5.5198 20.7366 5.53119C20.7361 5.54257 20.7327 5.55364 20.7267 5.56333C20.7207 5.57302 20.7123 5.58102 20.7023 5.58655C20.6924 5.59209 20.6811 5.59498 20.6697 5.59495H20.5052L20.6421 5.31761Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M20.213 5.81586C20.1238 5.77566 20.0486 5.71 19.9966 5.62714C19.9897 5.82778 20.0592 6.02357 20.1911 6.1749L20.213 5.81586Z"
        fill="#CE8172"
      />
      <path
        d="M19.7488 5.52818L20.0031 5.55119C20.0031 5.55119 20.3184 5.32105 20.2988 4.98388C20.2988 4.98388 20.5543 5.20022 20.7822 5.0276C21.01 4.85499 20.8903 4.48905 20.6153 4.37283C20.3403 4.2566 19.5302 4.12772 19.7488 5.52818Z"
        fill="#111111"
      />
      <path
        d="M19.437 6.42231L20.1757 6.62139C20.1757 6.62139 21.5566 7.31184 21.5808 8.69274C21.605 10.0736 19.7776 11.9908 19.7776 11.9908L17.3967 10.9413C17.3967 10.9413 16.7707 6.37628 19.437 6.42231Z"
        fill="#111111"
      />
      <path
        d="M23.8102 7.46834C23.8102 7.46834 23.9253 6.97582 24.3051 6.99653C24.6848 7.01724 24.1405 7.71114 24.1405 7.71114L23.8102 7.46834Z"
        fill="#F4A28C"
      />
      <path
        d="M19.3961 7.19907L19.2017 1.61103L18.5837 1.50977C18.5837 1.50977 17.5998 5.36132 17.8139 7.35672C18.0279 9.35212 19.3961 7.97467 19.3961 7.19907Z"
        fill="#111111"
      />
      <path
        opacity="0.46"
        d="M19.3961 7.19907L19.2017 1.61103L18.5837 1.50977C18.5837 1.50977 17.5998 5.36132 17.8139 7.35672C18.0279 9.35212 19.3961 7.97467 19.3961 7.19907Z"
        fill="white"
      />
      <path
        d="M19.1061 1.60299C19.1061 1.60299 19.3742 1.19563 19.1429 1.01381C18.9116 0.831991 18.7655 0.783659 18.6907 1.00115C18.6449 1.16855 18.632 1.34323 18.6527 1.51554L19.1061 1.60299Z"
        fill="#F4A28C"
      />
      <path
        d="M7.44268 4.98618C7.41676 5.20353 7.42025 5.42338 7.45303 5.6398C7.45847 5.66539 7.46896 5.68963 7.48388 5.71112C7.49879 5.7326 7.51785 5.7509 7.53992 5.76494C7.56199 5.77897 7.58664 5.78847 7.61242 5.79287C7.63821 5.79726 7.66461 5.79648 7.69009 5.79055C7.77316 5.77722 7.85061 5.74014 7.91308 5.68379C7.97556 5.62743 8.02041 5.55421 8.04221 5.47295L8.17109 5.12772C8.18986 5.05682 8.18609 4.98184 8.16032 4.91317C8.13454 4.84451 8.08804 4.78557 8.02725 4.74453C7.81091 4.58342 7.45879 4.74568 7.44268 4.98618Z"
        fill="#F4A28C"
      />
      <path d="M8.14868 5.19449L8.30978 6.47527L7.59747 6.51439L7.76663 5.56618L8.14868 5.19449Z" fill="#F4A28C" />
      <path
        d="M7.85034 5.33716C7.85034 5.33716 7.8584 5.18527 7.97117 5.20022C8.08394 5.21518 8.07473 5.43037 7.91938 5.44994L7.85034 5.33716Z"
        fill="#F4A28C"
      />
      <path
        d="M7.42899 5.23361L7.31391 5.38206C7.30748 5.39044 7.30325 5.4003 7.30161 5.41074C7.29997 5.42118 7.30097 5.43187 7.30451 5.44182C7.30806 5.45177 7.31404 5.46068 7.32192 5.46773C7.32979 5.47478 7.3393 5.47974 7.34959 5.48217L7.49919 5.51554L7.42899 5.23361Z"
        fill="#F4A28C"
      />
      <path
        d="M7.5973 6.52012C7.5973 6.52012 6.5087 6.68122 6.18534 5.30032C5.86198 3.91943 7.32112 2.88375 7.32112 2.88375C7.32112 2.88375 8.05645 2.68928 7.70777 2.29802C7.35909 1.90677 6.90225 2.59606 6.90225 2.59606C6.90225 2.59606 4.69282 3.61448 5.13701 5.56845C5.5812 7.52242 6.79638 8.14612 6.79638 8.14612L7.5973 6.52012Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M7.72015 5.77214C7.80793 5.75223 7.88795 5.70702 7.9503 5.64211C7.91665 5.82605 7.81471 5.99047 7.66492 6.10241L7.72015 5.77214Z"
        fill="#CE8172"
      />
      <path
        d="M6.67739 7.08053C6.67739 7.08053 5.22169 8.60872 6.30455 9.52932C7.3874 10.4499 7.90293 10.9712 7.90293 10.9712L9.91674 10.336C9.91674 10.336 9.82813 8.69733 10.1469 7.75832C10.4656 6.81931 9.934 6.27961 9.392 6.25659C8.85 6.23358 8.03642 5.95164 6.67739 7.08053Z"
        fill="#111111"
      />
      <path
        opacity="0.09"
        d="M8.14427 6.27385C8.14427 6.27385 7.36406 7.32219 8.03494 8.15072C8.70583 8.97926 8.97395 10.634 8.97395 10.634L9.91642 10.336C9.91642 10.336 9.87154 8.79629 10.0465 8.14957C10.133 7.87434 10.1995 7.5932 10.2455 7.30838C10.2732 7.02644 9.12585 6.07362 9.12585 6.07362L8.14427 6.27385Z"
        fill="#111111"
      />
      <path
        d="M9.59629 7.99078C8.87247 8.48445 8.08421 7.45798 8.72747 6.86305C8.90651 6.69432 9.09894 6.54039 9.30285 6.40275C10.0267 5.92634 10.8092 3.91598 9.87822 2.86765C9.87822 2.86765 9.34542 2.23359 9.76314 2.02645C10.1809 1.81932 10.2568 2.75948 10.2568 2.75948C10.2568 2.75948 11.7908 4.39009 11.0313 5.93324C10.6193 6.76753 10.1463 7.61564 9.59629 7.99078Z"
        fill="#F4A28C"
      />
      <path
        d="M7.8006 5.09436C7.8006 5.09436 7.80866 6.49137 8.7097 6.46376C9.61073 6.43614 9.82017 5.99655 9.95021 5.63637C10.0802 5.27618 8.49566 6.01842 8.42776 5.02417C8.35987 4.02992 7.53938 4.24741 7.3288 4.58113C7.11821 4.91485 7.8006 5.09436 7.8006 5.09436Z"
        fill="#111111"
      />
      <path
        d="M12.3915 0.861912C12.4352 0.898736 12.5756 0.724972 12.594 0.686998C12.6757 0.553769 12.7098 0.396766 12.6907 0.241657C12.6665 0.147296 12.5698 0.00345225 12.4605 0C12.3988 0.00713435 12.3404 0.0313955 12.2918 0.0700369C12.2432 0.108678 12.2064 0.160156 12.1855 0.218642C12.1388 0.304869 12.0969 0.393612 12.0601 0.484465C12.0313 0.567319 12.075 0.599541 12.1372 0.651324C12.2212 0.722671 12.3063 0.791716 12.3915 0.861912Z"
        fill="#F4A28C"
      />
      <path
        d="M12.2433 5.47524C12.2433 5.47524 12.05 2.80551 12.5724 0.895268L12.0592 0.484451C12.0592 0.484451 10.5736 3.92174 11.1386 7.4085L12.2433 5.47524Z"
        fill="#111111"
      />
      <path
        d="M16.3508 1.69274C16.2956 1.72726 16.2058 1.51782 16.1978 1.4879C16.1529 1.3245 16.0447 1.14268 16.1506 0.97352C16.1823 0.929192 16.2244 0.893249 16.2731 0.868791C16.3218 0.844332 16.3757 0.832093 16.4302 0.83313C16.5453 0.856144 16.6144 0.982726 16.6466 1.08514C16.6813 1.17692 16.7105 1.27068 16.734 1.36592C16.7501 1.45338 16.703 1.481 16.6339 1.52012L16.3508 1.69274Z"
        fill="#F4A28C"
      />
      <path
        d="M15.8348 6.27849C15.8348 6.27849 16.4102 3.66514 16.165 1.69967L16.7335 1.36595C16.7335 1.36595 17.7094 4.98045 16.6541 8.35098L15.8348 6.27849Z"
        fill="#111111"
      />
      <path
        opacity="0.46"
        d="M12.2433 5.47524C12.2433 5.47524 12.05 2.80551 12.5724 0.895268L12.0592 0.484451C12.0592 0.484451 10.5736 3.92174 11.1386 7.4085L12.2433 5.47524Z"
        fill="white"
      />
      <path
        opacity="0.46"
        d="M15.8348 6.27849C15.8348 6.27849 16.4102 3.66514 16.165 1.69967L16.7335 1.36595C16.7335 1.36595 17.7094 4.98045 16.6541 8.35098L15.8348 6.27849Z"
        fill="white"
      />
      <path
        d="M16.7353 7.65591C16.5178 9.95741 15.2876 11.8803 15.2876 11.8803L12.3256 11.7123C12.3256 11.7123 9.1035 5.37628 13.2462 5.28537H13.4292H14.0678C14.2541 5.29415 14.4395 5.31646 14.6225 5.35211C14.7145 5.36937 14.8135 5.39124 14.9182 5.41771C15.0672 5.45576 15.2136 5.50303 15.3567 5.55925C16.0943 5.84579 16.8503 6.43842 16.7353 7.65591Z"
        fill="#111111"
      />
      <path d="M15.448 12.5983L15.2858 11.8803L12.3237 11.7123L12.2432 12.5983H15.448Z" fill="#111111" />
      <path
        opacity="0.08"
        d="M15.3591 5.55694C15.29 6.00228 15.1174 6.46143 14.7089 6.64785C13.8113 7.05637 13.6974 6.16914 13.6974 6.16914C13.5823 5.98962 13.6974 5.649 13.8804 5.31989L14.519 5.33945C14.519 5.33945 14.5559 5.33945 14.6215 5.3498C14.7135 5.36707 14.8125 5.38893 14.9172 5.4154C15.0673 5.45332 15.2149 5.50059 15.3591 5.55694Z"
        fill="#111111"
      />
      <path
        d="M13.5472 5.16571C13.5807 5.29063 13.6069 5.41743 13.6254 5.54545C13.6496 5.72036 13.7336 5.97698 14.0167 5.99884C14.454 6.03337 14.4965 5.34407 14.4965 5.34407C14.4965 5.34407 14.7002 4.68009 14.2273 4.64097C13.8003 4.60645 13.401 4.59149 13.5472 5.16571Z"
        fill="#F4A28C"
      />
      <path
        d="M14.4728 5.3694C14.4728 5.3694 14.4728 5.16111 14.6569 5.15076C14.841 5.1404 14.8065 5.53741 14.4728 5.3694Z"
        fill="#F4A28C"
      />
      <path
        d="M13.6701 5.34176C13.6701 5.34176 13.7127 5.13808 13.5378 5.0886C13.3629 5.03912 13.3088 5.42922 13.6701 5.34176Z"
        fill="#F4A28C"
      />
      <path
        d="M13.5476 5.1657C13.5476 5.1657 12.8422 5.13924 13.1 4.59033C13.3578 4.04143 13.4659 4.42232 13.5706 4.01496C13.6754 3.6076 13.8008 3.51324 14.0309 3.65938C14.2611 3.80552 14.0919 4.18182 14.4072 4.04833C14.7225 3.91485 14.9343 3.79862 15.024 4.06214C15.1138 4.32566 15.0666 4.4603 14.8664 4.57422C14.6662 4.68815 15.0332 5.01726 14.5212 5.21979C14.0091 5.42232 13.6765 4.87457 13.6765 4.87457L13.5476 5.1657Z"
        fill="#111111"
      />
      <path
        d="M22.0621 10.0276V16.7204C22.0632 17.5337 21.9038 18.3392 21.593 19.0908C21.2823 19.8424 20.8263 20.5253 20.2512 21.1004C19.6761 21.6755 18.9932 22.1315 18.2416 22.4423C17.49 22.753 16.6844 22.9124 15.8711 22.9114H11.641C10.8279 22.9117 10.0227 22.7518 9.27141 22.4407C8.52015 22.1297 7.83753 21.6737 7.26258 21.0987C6.68763 20.5238 6.23162 19.8412 5.9206 19.0899C5.60958 18.3387 5.44965 17.5335 5.44995 16.7204V10.0276H22.0621Z"
        fill="#008B07"
      />
      <path d="M15.3169 21.267H12.1926V27.1427H15.3169V21.267Z" fill="#008B07" />
      <path d="M18.8257 26.0552H8.6842V28H18.8257V26.0552Z" fill="#008B07" />
      <path
        d="M5.53333 17.7388H4.54254C3.78754 17.7237 3.06855 17.4132 2.53994 16.8739C2.01132 16.3346 1.71523 15.6096 1.71523 14.8544C1.71523 14.0993 2.01132 13.3742 2.53994 12.835C3.06855 12.2957 3.78754 11.9852 4.54254 11.9701H5.44933V10.8193H4.54254C3.48417 10.8372 2.47519 11.2702 1.73304 12.025C0.990898 12.7798 0.575012 13.7959 0.575012 14.8544C0.575012 15.913 0.990898 16.9291 1.73304 17.6839C2.47519 18.4387 3.48417 18.8717 4.54254 18.8895H5.83943C5.7006 18.5167 5.59809 18.1313 5.53333 17.7388Z"
        fill="#008B07"
      />
      <path
        d="M22.9641 10.8193H22.0573V11.9701H22.9641C23.7191 11.9852 24.4381 12.2957 24.9667 12.835C25.4953 13.3742 25.7914 14.0993 25.7914 14.8544C25.7914 15.6096 25.4953 16.3346 24.9667 16.8739C24.4381 17.4132 23.7191 17.7237 22.9641 17.7388H21.9733C21.9085 18.1313 21.806 18.5167 21.6672 18.8895H22.9641C24.0224 18.8717 25.0314 18.4387 25.7736 17.6839C26.5157 16.9291 26.9316 15.913 26.9316 14.8544C26.9316 13.7959 26.5157 12.7798 25.7736 12.025C25.0314 11.2702 24.0224 10.8372 22.9641 10.8193Z"
        fill="#008B07"
      />
      <path d="M5.19141 21.4116L2.98328 20.8639L2.82925 21.4849L5.03738 22.0326L5.19141 21.4116Z" fill="#E7E7E7" />
      <path d="M10.0727 23.6943L7.83124 24.0835L7.94069 24.7139L10.1822 24.3247L10.0727 23.6943Z" fill="#E7E7E7" />
      <path d="M22.1447 22.6252L20.1029 23.6286L20.3851 24.2028L22.4269 23.1994L22.1447 22.6252Z" fill="#E7E7E7" />
      <path d="M4.17182 8.35918L2.98102 8.94435L3.14546 9.27897L4.33626 8.6938L4.17182 8.35918Z" fill="#E7E7E7" />
      <path d="M3.15562 5.4424L1.85614 5.17447L1.78085 5.53963L3.08033 5.80756L3.15562 5.4424Z" fill="#E7E7E7" />
      <path d="M26.0234 9.53276L24.7239 9.26483L24.6486 9.63L25.9481 9.89793L26.0234 9.53276Z" fill="#E7E7E7" />
      <path d="M23.3912 4.59358L22.2819 5.32144L22.4864 5.63317L23.5958 4.90531L23.3912 4.59358Z" fill="#E7E7E7" />
      <path d="M25.5614 20.0682L23.2877 20.1437L23.3089 20.7831L25.5826 20.7077L25.5614 20.0682Z" fill="#E7E7E7" />
      <path
        opacity="0.43"
        d="M13.9432 12.924L14.8155 14.6904C14.8302 14.7207 14.852 14.747 14.879 14.7671C14.9061 14.7871 14.9376 14.8003 14.9709 14.8055L16.9202 15.0886C16.9585 15.0941 16.9944 15.1102 17.024 15.1351C17.0536 15.16 17.0756 15.1927 17.0876 15.2295C17.0996 15.2662 17.101 15.3056 17.0918 15.3431C17.0825 15.3807 17.063 15.4149 17.0353 15.4419L15.6245 16.8159C15.6005 16.8395 15.5826 16.8686 15.5721 16.9006C15.5617 16.9327 15.5592 16.9667 15.5646 17L15.8984 18.9401C15.9049 18.9782 15.9007 19.0174 15.8862 19.0532C15.8717 19.089 15.8474 19.1201 15.8161 19.1428C15.7849 19.1656 15.7479 19.1791 15.7094 19.1819C15.6708 19.1848 15.6322 19.1767 15.598 19.1588L13.8546 18.2382C13.8249 18.2223 13.7917 18.2139 13.758 18.2139C13.7242 18.2139 13.691 18.2223 13.6613 18.2382L11.9179 19.1588C11.8837 19.1767 11.8451 19.1848 11.8066 19.1819C11.768 19.1791 11.731 19.1656 11.6998 19.1428C11.6685 19.1201 11.6443 19.089 11.6298 19.0532C11.6152 19.0174 11.611 18.9782 11.6176 18.9401L11.9513 17C11.9568 16.9667 11.9542 16.9327 11.9438 16.9006C11.9334 16.8686 11.9154 16.8395 11.8915 16.8159L10.4806 15.4419C10.453 15.4149 10.4334 15.3807 10.4242 15.3431C10.4149 15.3056 10.4164 15.2662 10.4283 15.2295C10.4403 15.1927 10.4623 15.16 10.4919 15.1351C10.5215 15.1102 10.5575 15.0941 10.5957 15.0886L12.5451 14.8055C12.5783 14.8003 12.6099 14.7871 12.6369 14.7671C12.664 14.747 12.6858 14.7207 12.7004 14.6904L13.5727 12.924C13.5896 12.8893 13.6159 12.86 13.6487 12.8395C13.6814 12.8189 13.7193 12.8081 13.758 12.8081C13.7966 12.8081 13.8345 12.8189 13.8673 12.8395C13.9 12.86 13.9263 12.8893 13.9432 12.924Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const EventIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "20", fill: "none" }}
      width="29"
      height="20"
      viewBox="0 0 29 20"
      fill="none"
    >
      <path
        d="M12.1112 1.38484C12.1112 1.38484 12.1306 2.09555 12.3025 2.54635C12.3194 2.59001 12.3448 2.62992 12.3771 2.66378C12.4095 2.69764 12.4483 2.72478 12.4912 2.74365C12.5341 2.76252 12.5803 2.77274 12.6272 2.77373C12.6741 2.77472 12.7207 2.76645 12.7644 2.74941C12.9913 2.66006 13.2731 2.47223 13.3087 2.09149L13.4481 1.4549C13.4629 1.32401 13.4366 1.19176 13.3728 1.07645C13.309 0.961131 13.2109 0.868443 13.092 0.811199C12.6617 0.571588 12.0777 0.954356 12.1112 1.38484Z"
        fill="#F4A28C"
      />
      <path d="M13.097 1.46095L14.3972 3.38698L13.2822 4.0256L12.7836 2.36863L13.097 1.46095Z" fill="#F4A28C" />
      <path
        d="M12.9289 1.90162C12.9289 1.90162 12.9025 1.63054 13.106 1.62749C13.3094 1.62444 13.3522 2.01737 13.0785 2.08539L12.9289 1.90162Z"
        fill="#F4A28C"
      />
      <path
        d="M12.1455 1.83055L11.9807 2.12398C11.9711 2.14057 11.966 2.15931 11.9657 2.17844C11.9654 2.19757 11.97 2.21645 11.9791 2.23331C11.9882 2.25017 12.0014 2.26445 12.0175 2.27481C12.0336 2.28517 12.0521 2.29126 12.0712 2.29252L12.3469 2.31282L12.1455 1.83055Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M12.8711 2.69054C12.9842 2.57107 13.0596 2.42099 13.0878 2.25903C13.0878 2.25903 13.219 2.65602 13.0522 3.26012L12.8711 2.69054Z"
        fill="#CE8172"
      />
      <path
        d="M13.2837 2.08131C13.3832 2.08131 13.4638 2.00085 13.4638 1.9016C13.4638 1.80235 13.3832 1.72189 13.2837 1.72189C13.1843 1.72189 13.1036 1.80235 13.1036 1.9016C13.1036 2.00085 13.1843 2.08131 13.2837 2.08131Z"
        fill="#F4A28C"
      />
      <path
        d="M12.2475 1.48229C12.4805 1.59803 12.5375 1.57062 12.8712 1.51783C12.8712 1.51783 13.0045 3.22454 14.0555 2.67527C14.7035 2.33616 14.0046 1.90161 13.68 1.12084C13.3555 0.340078 13.1713 0.0943752 12.6514 0.239563C12.4494 0.30796 12.2666 0.423525 12.1183 0.576643C12.0531 0.63821 12.0036 0.714488 11.974 0.799079C11.9444 0.88367 11.9356 0.974109 11.9482 1.06281C11.9609 1.15152 11.9947 1.2359 12.0467 1.30889C12.0988 1.38187 12.1677 1.44134 12.2475 1.48229Z"
        fill="#111111"
      />
      <path
        d="M15.1706 12.1612L14.7707 13.5116C14.6302 13.9863 14.5915 14.4852 14.657 14.9759C14.7225 15.4665 14.8909 15.9379 15.1511 16.3593C15.4112 16.7808 15.7575 17.1428 16.1672 17.4218C16.5769 17.7009 17.0408 17.8907 17.5289 17.9789L20.746 18.5606V17.653L18.3367 16.6691C18.1453 16.5907 17.9713 16.4751 17.825 16.3291C17.6786 16.183 17.5628 16.0094 17.4842 15.8183C17.4057 15.6273 17.3659 15.4225 17.3673 15.216C17.3687 15.0094 17.4112 14.8052 17.4923 14.6152L18.0183 13.3836L15.1706 12.1612Z"
        fill="#F4A28C"
      />
      <path
        d="M19.7606 3.05295L23.9503 5.05512C24.3491 5.24607 24.6885 5.54156 24.9321 5.91L26.8407 8.78736L26.1713 9.4534L22.7498 6.92835L18.2946 5.7303L19.7606 3.05295Z"
        fill="#F4A28C"
      />
      <path
        d="M13.2824 4.02562L14.4015 3.387C14.4015 3.387 16.592 1.28939 19.7653 3.05296C22.9386 4.81654 18.2951 11.9307 18.2951 11.9307L13.6436 11.2343C13.6436 11.2343 14.7342 8.9681 11.7349 7.42586L10.5568 6.28873C10.5568 6.28873 12.1683 4.66526 13.2824 4.02562Z"
        fill="#008B07"
      />
      <path
        opacity="0.08"
        d="M19.341 6.97706C19.341 6.97706 20.0481 7.75681 18.7784 8.15887C17.5087 8.56093 16.0314 10.1022 15.5573 11.5205L13.6476 11.2342C13.6476 11.2342 13.9803 10.625 13.7677 9.64831C13.5551 8.67159 17.1048 6.74658 19.341 6.97706Z"
        fill="#111111"
      />
      <path
        d="M10.5565 6.28873C10.5565 6.28873 8.96425 7.60862 9.59911 9.07979C10.234 10.551 13.2272 10.2027 15.7137 8.79144C18.2002 7.38017 18.6051 7.14056 18.6051 7.14056L18.1432 6.28974L13.0044 7.85127L10.5565 6.28873Z"
        fill="#F4A28C"
      />
      <path
        d="M18.1436 6.28874C18.1436 6.28874 19.5293 6.05522 19.8091 6.57302C20.3259 7.5274 18.7785 7.45836 18.6055 7.13956L18.1436 6.28874Z"
        fill="#111111"
      />
      <path d="M19.3412 2.83875L22.8217 4.51602L22.2479 6.79436L20.3718 6.28874L19.3412 2.83875Z" fill="#008B07" />
      <path d="M21.7281 3.98906L21.2672 6.53036L22.0394 6.72732L22.5481 4.38401L21.7281 3.98906Z" fill="#111111" />
      <path
        d="M18.4229 11.7906L13.6045 10.952C12.1876 10.7051 10.7334 10.7765 9.34769 11.1611L5.1275 12.3318V13.4598L10.6021 13.0405C11.1866 12.9957 11.7742 13.0162 12.3541 13.1014L16.2202 13.6699C16.4698 13.7065 16.7241 13.6934 16.9685 13.6314C17.2129 13.5694 17.4426 13.4598 17.6443 13.3087C17.8461 13.1577 18.0159 12.9683 18.1439 12.7515C18.2719 12.5347 18.3557 12.2947 18.3904 12.0455L18.4229 11.7906Z"
        fill="#F4A28C"
      />
      <path
        d="M12.4857 10.5479L12.3473 13.2892C12.3473 13.2892 17.415 14.5076 18.2991 13.9532C19.1832 13.3988 18.4232 11.7947 18.4232 11.7947L12.4857 10.5479Z"
        fill="#111111"
      />
      <path
        d="M5.12788 12.3318C5.12788 12.3318 3.4807 11.614 2.84584 11.9308C2.21098 12.2475 4.40451 13.2507 4.40451 13.2507C4.40451 13.2507 4.49607 14.0913 5.12788 13.4537V12.3318Z"
        fill="#008B07"
      />
      <path
        d="M20.4887 18.5038C20.4887 18.5038 21.6272 19.4247 22.1939 19.3161C22.7606 19.2074 21.2589 17.9383 21.2589 17.9383C21.2589 17.9383 21.3688 17.2581 20.7339 17.6205L20.4887 18.5038Z"
        fill="#008B07"
      />
      <path d="M5.1275 12.3318L9.34769 11.1611L9.44943 13.1288L5.1275 13.4598V12.3318Z" fill="#008B07" />
      <path opacity="0.46" d="M5.1275 12.3318L9.34769 11.1611L9.44943 13.1288L5.1275 13.4598V12.3318Z" fill="white" />
      <path
        d="M12.1108 1.38484L12.1251 1.6275C12.1251 1.6275 12.2757 1.82548 12.8892 1.66405L12.8708 1.51785C12.8708 1.51785 12.4211 1.56861 12.1108 1.38484Z"
        fill="#008B07"
      />
      <path
        d="M14.3968 13.4598C14.3968 13.4598 14.1252 15.9351 15.3552 16.6549L17.4918 15.8427C17.4918 15.8427 17.2334 15.2559 17.7156 14.0822C18.1979 12.9085 14.3968 13.4598 14.3968 13.4598Z"
        fill="#111111"
      />
      <path d="M20.734 17.6175L18.337 16.6692L17.7611 18.0205L20.4888 18.5038L20.734 17.6175Z" fill="#008B07" />
      <path
        opacity="0.46"
        d="M20.734 17.6175L18.337 16.6692L17.7611 18.0205L20.4888 18.5038L20.734 17.6175Z"
        fill="white"
      />
      <path
        opacity="0.08"
        d="M13.0044 7.85125L11.9656 8.06751C11.9656 8.06751 11.5444 6.93748 12.3471 6.28465C13.1499 5.63181 14.4257 6.27246 14.9568 7.25629L13.0044 7.85125Z"
        fill="#111111"
      />
      <path
        opacity="0.46"
        d="M17.1437 5.63083C17.4848 5.63083 17.7612 5.35491 17.7612 5.01454C17.7612 4.67418 17.4848 4.39825 17.1437 4.39825C16.8026 4.39825 16.5261 4.67418 16.5261 5.01454C16.5261 5.35491 16.8026 5.63083 17.1437 5.63083Z"
        fill="white"
      />
      <path
        d="M26.1678 9.45344C26.1678 9.45344 26.8312 10.3185 27.8415 9.88595C28.8518 9.45344 26.8414 8.7874 26.8414 8.7874L26.1678 9.45344Z"
        fill="#111111"
      />
      <path
        d="M0.125 9.11064C0.125001 9.43815 0.222277 9.75831 0.40454 10.0307C0.586804 10.3031 0.845879 10.5154 1.14905 10.641C1.45221 10.7665 1.78587 10.7996 2.10789 10.7361C2.4299 10.6726 2.72582 10.5153 2.95827 10.284C3.19072 10.0528 3.34928 9.75802 3.41392 9.43693C3.47856 9.11584 3.44638 8.78284 3.32144 8.47998C3.19651 8.17713 2.98442 7.91801 2.71197 7.73535C2.43952 7.55268 2.11893 7.45467 1.79068 7.45369C1.57222 7.45321 1.35581 7.4957 1.15382 7.57873C0.951836 7.66177 0.768238 7.78372 0.613532 7.93761C0.458827 8.09151 0.336048 8.27432 0.252221 8.4756C0.168394 8.67688 0.125163 8.89268 0.125 9.11064Z"
        fill="white"
      />
      <path
        d="M0.125003 9.11064C0.125133 8.78251 0.222909 8.4618 0.405936 8.18918C0.588964 7.91655 0.849001 7.70428 1.15308 7.57928C1.45717 7.45428 1.7916 7.42218 2.11399 7.48704C2.43638 7.5519 2.73221 7.71081 2.96398 7.94362C3.19575 8.17643 3.35302 8.47265 3.41585 8.79474C3.47868 9.11683 3.44425 9.45028 3.31691 9.75282C3.18958 10.0554 2.97508 10.3134 2.7006 10.4941C2.42613 10.6749 2.10404 10.7703 1.77517 10.7682C1.33624 10.7661 0.91606 10.5904 0.606735 10.2797C0.297411 9.96898 0.124176 9.54858 0.125003 9.11064ZM2.81195 8.59343C2.79542 8.3889 2.75649 8.1868 2.69586 7.99073C2.69283 7.98284 2.68712 7.97626 2.67971 7.97215C2.52079 7.87343 2.35257 7.79044 2.17746 7.72438C2.16874 7.72192 2.1595 7.72192 2.15077 7.72438L1.95272 7.78632C1.81929 7.82649 1.69206 7.88485 1.57464 7.95976C1.57014 7.96144 1.56641 7.96469 1.56413 7.9689C1.56184 7.97311 1.56117 7.97801 1.56222 7.98268C1.5914 8.17408 1.61996 8.36548 1.64914 8.55626C1.64998 8.56022 1.65163 8.56397 1.65398 8.56727C1.65633 8.57057 1.65933 8.57336 1.6628 8.57547C1.86974 8.6754 2.07544 8.77471 2.2799 8.87341C2.28746 8.8765 2.29593 8.8765 2.30349 8.87341L2.80015 8.60644C2.80388 8.60706 2.8076 8.599 2.81195 8.59343ZM0.905385 9.07658L1.11398 9.08711C1.12162 9.08751 1.12914 9.08508 1.13509 9.08029C1.29154 8.91883 1.44716 8.75696 1.60195 8.59467C1.60663 8.58939 1.60908 8.58251 1.60878 8.57547C1.58105 8.38675 1.5527 8.19783 1.52373 8.0087C1.52001 7.98144 1.52001 7.98144 1.49083 7.97772C1.33553 7.95452 1.17828 7.94705 1.02148 7.95542C1.01091 7.95604 1.00085 7.96018 0.992922 7.96719C0.842464 8.10626 0.702209 8.25592 0.573241 8.41504C0.568715 8.42109 0.566513 8.42856 0.567033 8.4361C0.576346 8.50485 0.586279 8.57299 0.596212 8.64112C0.615419 8.77916 0.642155 8.91605 0.676299 9.05118C0.676299 9.06047 0.680645 9.06667 0.693061 9.06729C0.763836 9.06914 0.83461 9.07286 0.905385 9.07658ZM2.82561 8.64298L2.80947 8.65165L2.32398 8.91305C2.31811 8.91576 2.3131 8.92002 2.30949 8.92537C2.30587 8.93072 2.3038 8.93696 2.30349 8.9434C2.28735 9.06729 2.26997 9.19117 2.2532 9.31196C2.23955 9.40735 2.22651 9.50336 2.21409 9.59937C2.21353 9.6036 2.21391 9.6079 2.21519 9.61196C2.21648 9.61603 2.21865 9.61977 2.22154 9.62291L2.5481 9.91527C2.55096 9.91725 2.55421 9.9186 2.55764 9.91924C2.56106 9.91988 2.56458 9.91979 2.56796 9.91899C2.75 9.85896 2.92155 9.77098 3.07642 9.65821C3.08814 9.65002 3.09616 9.63756 3.09877 9.62352C3.12811 9.48307 3.14885 9.34096 3.16086 9.19798C3.16231 9.18425 3.16017 9.17038 3.15465 9.15772C3.11305 9.0741 3.07332 8.98986 3.03048 8.90995C2.97216 8.81377 2.90346 8.72425 2.82561 8.64298ZM0.890485 9.11684L0.681887 9.10755C0.678163 9.10777 0.674526 9.10876 0.671211 9.11047C0.667896 9.11218 0.664977 9.11456 0.662641 9.11746C0.642154 9.14905 0.622287 9.1794 0.600558 9.21347C0.542486 9.32588 0.499487 9.44542 0.472667 9.56902C0.471882 9.57498 0.472966 9.58104 0.475771 9.58636C0.545328 9.73241 0.622628 9.87467 0.707341 10.0125C0.712337 10.0195 0.719233 10.0249 0.727207 10.028C0.80419 10.0497 0.881173 10.0738 0.960018 10.09C1.07479 10.1114 1.19162 10.1199 1.3083 10.1153C1.3201 10.1153 1.32072 10.1073 1.32382 10.0999C1.36521 9.98795 1.40515 9.87584 1.44364 9.76351C1.44609 9.75894 1.44737 9.75383 1.44737 9.74865C1.44737 9.74346 1.44609 9.73836 1.44364 9.73378L1.12516 9.13976C1.12318 9.13537 1.11994 9.13167 1.11585 9.12914C1.11176 9.1266 1.107 9.12534 1.10219 9.12551L0.890485 9.11684ZM1.80869 10.4969H1.81738C1.97784 10.4808 2.13683 10.4524 2.29294 10.412C2.30006 10.4098 2.30634 10.4055 2.31094 10.3997C2.40798 10.2696 2.47978 10.1225 2.52264 9.96607C2.52444 9.96111 2.52456 9.9557 2.52299 9.95067C2.52143 9.94564 2.51825 9.94126 2.51395 9.93819C2.40883 9.84528 2.30535 9.75216 2.20354 9.65883C2.19834 9.65369 2.19187 9.65 2.18478 9.64816C2.17769 9.64631 2.17024 9.64636 2.16318 9.6483L1.51069 9.76475C1.50535 9.76521 1.50028 9.7673 1.49617 9.77073C1.49206 9.77417 1.48911 9.77879 1.48772 9.78396C1.44923 9.89297 1.41074 10.0014 1.37101 10.1098C1.36822 10.1164 1.36733 10.1237 1.36843 10.1308C1.36952 10.1379 1.37256 10.1445 1.37721 10.15C1.48643 10.2986 1.63199 10.4167 1.8 10.4932C1.80276 10.4947 1.80568 10.496 1.80869 10.4969ZM0.282073 8.52467L0.304422 8.51538L0.508675 8.42309C0.518815 8.41806 0.527881 8.41112 0.535371 8.40265C0.673702 8.23364 0.823465 8.07429 0.983609 7.92569C0.989769 7.91961 0.994442 7.91219 0.997268 7.90401L1.05128 7.76712L1.09536 7.65562C0.724084 7.83145 0.433606 8.14142 0.282694 8.52281L0.282073 8.52467ZM3.34276 8.70245L3.33717 8.71855C3.29578 8.84491 3.25564 8.97127 3.21673 9.09764C3.21002 9.1137 3.20543 9.13057 3.20307 9.14781C3.19054 9.31452 3.16606 9.48012 3.12981 9.64335C3.12535 9.65948 3.12326 9.67617 3.12361 9.6929C3.13168 9.75856 3.14161 9.8236 3.15092 9.88926C3.15092 9.90908 3.15651 9.92952 3.16024 9.9543C3.2853 9.75148 3.36336 9.52334 3.3887 9.28656C3.41101 9.09072 3.39541 8.89242 3.34276 8.70245ZM1.56719 10.7057C1.76363 10.7325 1.96335 10.7231 2.15635 10.6778C2.34768 10.6332 2.52883 10.5529 2.69027 10.4412C2.57976 10.4368 2.46925 10.435 2.35937 10.4331C2.35307 10.4335 2.34683 10.4346 2.34074 10.4362C2.18107 10.4791 2.01836 10.5097 1.85401 10.5279C1.82897 10.5279 1.80452 10.5354 1.78386 10.5496C1.71805 10.5991 1.65038 10.6456 1.58333 10.6933L1.56719 10.7057ZM0.735899 10.334C0.735899 10.3266 0.735899 10.3235 0.735899 10.321C0.724724 10.2467 0.71417 10.173 0.702995 10.0992C0.701559 10.081 0.696716 10.0631 0.688716 10.0466C0.598064 9.89775 0.515177 9.74435 0.440384 9.58698C0.436714 9.57965 0.431893 9.57296 0.426105 9.56716L0.20509 9.37638L0.193915 9.36894C0.226771 9.57332 0.299091 9.76938 0.406859 9.94624C0.495328 10.0917 0.606153 10.2223 0.735278 10.3334L0.735899 10.334ZM1.96762 7.51068L1.97631 7.51997C2.03405 7.57138 2.09117 7.62342 2.1489 7.67421C2.15459 7.67905 2.16111 7.68283 2.16815 7.68536C2.35643 7.75467 2.53735 7.84244 2.70827 7.94737C2.72075 7.95438 2.73444 7.95901 2.74863 7.961C2.77656 7.96472 2.80512 7.96719 2.83368 7.96967L2.92742 7.97834C2.67099 7.71685 2.33198 7.55167 1.96762 7.51068Z"
        fill="#111111"
      />
      <path
        d="M2.81166 8.59341C2.80731 8.59898 2.80359 8.60703 2.79738 8.61013L2.30072 8.8771C2.29316 8.8802 2.28468 8.8802 2.27712 8.8771C2.07018 8.77882 1.86448 8.6795 1.66002 8.57916C1.65655 8.57705 1.65355 8.57427 1.6512 8.57096C1.64886 8.56766 1.64721 8.56392 1.64636 8.55996C1.61718 8.36917 1.58862 8.17777 1.55945 7.98637C1.55839 7.9817 1.55907 7.9768 1.56135 7.97259C1.56363 7.96838 1.56737 7.96513 1.57186 7.96345C1.68928 7.88854 1.81651 7.83018 1.94995 7.79002L2.14799 7.72807C2.15672 7.72561 2.16596 7.72561 2.17469 7.72807C2.3498 7.79413 2.51801 7.87712 2.67694 7.97584C2.68434 7.97995 2.69006 7.98653 2.69308 7.99442C2.75429 8.1892 2.79405 8.39004 2.81166 8.59341Z"
        fill="white"
      />
      <path
        d="M0.905504 9.07657C0.83473 9.07285 0.763955 9.06914 0.693181 9.06666C0.680764 9.06666 0.678902 9.05984 0.676419 9.05055C0.642274 8.91542 0.615538 8.77853 0.596332 8.6405C0.586398 8.57236 0.576465 8.50422 0.567153 8.43547C0.566632 8.42793 0.568835 8.42046 0.573361 8.41441C0.702329 8.2553 0.842583 8.10563 0.993041 7.96657C1.00097 7.95956 1.01103 7.95541 1.0216 7.9548C1.1784 7.94642 1.33565 7.95389 1.49095 7.9771C1.52012 7.98081 1.52012 7.98081 1.52385 8.00807C1.55241 8.1972 1.58076 8.38612 1.6089 8.57484C1.6092 8.58188 1.60675 8.58876 1.60207 8.59404C1.44687 8.75633 1.29125 8.9182 1.13521 9.07966C1.12926 9.08445 1.12174 9.08688 1.1141 9.08648L0.905504 9.07595V9.07657Z"
        fill="white"
      />
      <path
        d="M2.82521 8.64299C2.90299 8.72387 2.97169 8.81297 3.03008 8.90872C3.0754 8.98987 3.11514 9.07411 3.15425 9.15649C3.15977 9.16915 3.16191 9.18302 3.16046 9.19675C3.14845 9.33973 3.12772 9.48184 3.09838 9.62229C3.09577 9.63633 3.08774 9.64879 3.07603 9.65698C2.92115 9.76974 2.74961 9.85773 2.56757 9.91776C2.56418 9.91856 2.56066 9.91865 2.55724 9.91801C2.55381 9.91737 2.55056 9.91602 2.5477 9.91404L2.22114 9.62167C2.21825 9.61853 2.21608 9.6148 2.21479 9.61073C2.21351 9.60667 2.21313 9.60237 2.21369 9.59814C2.22611 9.50213 2.23915 9.40612 2.25281 9.31073C2.26957 9.18684 2.28695 9.06296 2.30309 8.94217C2.3034 8.93573 2.30548 8.92949 2.30909 8.92414C2.3127 8.91879 2.31771 8.91453 2.32358 8.91182L2.80907 8.65042L2.82521 8.64299Z"
        fill="white"
      />
      <path
        d="M0.890347 9.11685L1.10267 9.12738C1.10749 9.12721 1.11224 9.12847 1.11634 9.13101C1.12043 9.13355 1.12367 9.13724 1.12564 9.14163L1.44413 9.73566C1.44657 9.74023 1.44785 9.74534 1.44785 9.75052C1.44785 9.75571 1.44657 9.76081 1.44413 9.76539C1.40274 9.87771 1.3628 9.98983 1.32431 10.1017C1.32431 10.1092 1.32058 10.1172 1.30879 10.1172C1.1921 10.1218 1.07527 10.1133 0.9605 10.0918C0.881655 10.0739 0.804672 10.0497 0.727689 10.0299C0.719715 10.0267 0.712818 10.0214 0.707823 10.0144C0.623109 9.87654 0.545811 9.73429 0.476254 9.58823C0.473448 9.58291 0.472364 9.57685 0.473149 9.57089C0.499969 9.44729 0.542968 9.32775 0.60104 9.21534C0.619665 9.18251 0.639531 9.1534 0.663123 9.11933C0.665459 9.11643 0.668378 9.11405 0.671693 9.11234C0.675008 9.11063 0.678645 9.10964 0.682369 9.10942L0.890968 9.11871L0.890347 9.11685Z"
        fill="white"
      />
      <path
        d="M1.80899 10.4969C1.80512 10.4961 1.80137 10.4949 1.79781 10.4932C1.6298 10.4167 1.48424 10.2986 1.37503 10.15C1.37038 10.1445 1.36733 10.1379 1.36624 10.1308C1.36514 10.1237 1.36604 10.1164 1.36882 10.1098C1.40855 10.0014 1.44704 9.89296 1.48553 9.78394C1.48692 9.77877 1.48987 9.77415 1.49398 9.77072C1.49809 9.76728 1.50316 9.76519 1.5085 9.76474L2.16348 9.64829C2.17054 9.64634 2.17799 9.64629 2.18507 9.64814C2.19216 9.64999 2.19863 9.65367 2.20383 9.65882C2.30772 9.75214 2.41119 9.84526 2.51425 9.93818C2.51855 9.94124 2.52172 9.94562 2.52329 9.95065C2.52486 9.95569 2.52474 9.96109 2.52294 9.96605C2.48008 10.1225 2.40828 10.2695 2.31124 10.3996C2.30664 10.4055 2.30036 10.4098 2.29323 10.412C2.13712 10.4524 1.97814 10.4808 1.81768 10.4969H1.80899Z"
        fill="white"
      />
      <path
        d="M0.281677 8.52464C0.43259 8.14324 0.723068 7.83327 1.09434 7.65744L1.05026 7.76894L0.996252 7.90583C0.993426 7.91401 0.988753 7.92143 0.982593 7.92751C0.822663 8.07613 0.673108 8.23549 0.534976 8.40447C0.527486 8.41294 0.51842 8.41988 0.50828 8.42491L0.304027 8.51721L0.281677 8.52464Z"
        fill="white"
      />
      <path
        d="M3.34278 8.70245C3.3952 8.89184 3.4108 9.08948 3.38873 9.28471C3.36338 9.5215 3.28533 9.74964 3.16026 9.95245C3.15654 9.92768 3.15343 9.90724 3.15095 9.88741C3.14164 9.82175 3.1317 9.75672 3.12363 9.69106C3.12329 9.67433 3.12538 9.65763 3.12984 9.6415C3.16609 9.47828 3.19057 9.31268 3.2031 9.14596C3.20545 9.12872 3.21004 9.11185 3.21676 9.09579C3.25815 8.96943 3.29829 8.84306 3.3372 8.7167L3.34278 8.70245Z"
        fill="white"
      />
      <path
        d="M1.56763 10.7057L1.58377 10.6933C1.65082 10.6456 1.71849 10.5992 1.7843 10.5496C1.80495 10.5355 1.82941 10.5279 1.85445 10.5279C2.01879 10.5098 2.18151 10.4791 2.34118 10.4362C2.34727 10.4346 2.35351 10.4336 2.35981 10.4332C2.46969 10.4332 2.5802 10.4369 2.69071 10.4412C2.52927 10.5529 2.34812 10.6332 2.15679 10.6778C1.96379 10.7231 1.76406 10.7326 1.56763 10.7057Z"
        fill="white"
      />
      <path
        d="M0.734865 10.3334C0.605027 10.2223 0.493565 10.0914 0.404584 9.94566C0.297109 9.76893 0.225003 9.57309 0.192261 9.36897L0.203436 9.37641L0.424451 9.56657C0.430239 9.57237 0.43506 9.57907 0.43873 9.58639C0.513522 9.74376 0.59641 9.89717 0.687062 10.046C0.695062 10.0625 0.699904 10.0804 0.70134 10.0987C0.712515 10.1724 0.723069 10.2461 0.734244 10.3204C0.734865 10.3229 0.734865 10.326 0.734865 10.3334Z"
        fill="white"
      />
      <path
        d="M1.96741 7.5107C2.33176 7.55169 2.67078 7.71687 2.92721 7.97836L2.83346 7.96969C2.80491 7.96969 2.77635 7.96473 2.74841 7.96101C2.73422 7.95902 2.72054 7.9544 2.70806 7.94739C2.53714 7.84245 2.35621 7.75468 2.16794 7.68537C2.1609 7.68284 2.15438 7.67907 2.14869 7.67422C2.09095 7.62343 2.03384 7.5714 1.9761 7.51999L1.96741 7.5107Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const ServiceIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "22", height: "28", fill: "none" }}
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
    >
      <path
        d="M19.4576 21.5722H19.199V21.1555C19.199 21.0417 19.1538 20.9326 19.0734 20.8521C18.9929 20.7717 18.8838 20.7265 18.7701 20.7265H17.2441C17.1302 20.7265 17.021 20.7717 16.9403 20.8521C16.8597 20.9325 16.8142 21.0416 16.8139 21.1555V21.5722H16.5565V21.1555C16.5565 21.0652 16.5743 20.9758 16.6089 20.8924C16.6434 20.8089 16.6941 20.7331 16.7579 20.6693C16.8218 20.6054 16.8976 20.5548 16.981 20.5202C17.0644 20.4857 17.1538 20.4679 17.2441 20.4679H18.7701C18.8603 20.4679 18.9498 20.4857 19.0332 20.5202C19.1166 20.5548 19.1924 20.6054 19.2563 20.6693C19.3201 20.7331 19.3707 20.8089 19.4053 20.8924C19.4399 20.9758 19.4576 21.0652 19.4576 21.1555V21.5722Z"
        fill="#707070"
      />
      <path
        opacity="0.51"
        d="M19.4576 21.5722H19.199V21.1555C19.199 21.0417 19.1538 20.9326 19.0734 20.8521C18.9929 20.7717 18.8838 20.7265 18.7701 20.7265H17.2441C17.1302 20.7265 17.021 20.7717 16.9403 20.8521C16.8597 20.9325 16.8142 21.0416 16.8139 21.1555V21.5722H16.5565V21.1555C16.5565 21.0652 16.5743 20.9758 16.6089 20.8924C16.6434 20.8089 16.6941 20.7331 16.7579 20.6693C16.8218 20.6054 16.8976 20.5548 16.981 20.5202C17.0644 20.4857 17.1538 20.4679 17.2441 20.4679H18.7701C18.8603 20.4679 18.9498 20.4857 19.0332 20.5202C19.1166 20.5548 19.1924 20.6054 19.2563 20.6693C19.3201 20.7331 19.3707 20.8089 19.4053 20.8924C19.4399 20.9758 19.4576 21.0652 19.4576 21.1555V21.5722Z"
        fill="white"
      />
      <path d="M9.53618 1.35764L8.34332 0.586243L6.83447 2.91945L8.02733 3.69085L9.53618 1.35764Z" fill="#707070" />
      <path
        d="M1.97808 8.23825C1.97808 8.23825 4.42327 5.52832 8.41893 4.81499L6.56573 10.051C6.56573 10.051 3.98081 11.4372 1.55768 11.3416L1.97808 8.23825Z"
        fill="#008B07"
      />
      <path
        opacity="0.08"
        d="M1.97808 8.23825C1.97808 8.23825 4.42327 5.52832 8.41893 4.81499L6.56573 10.051C6.56573 10.051 3.98081 11.4372 1.55768 11.3416L1.97808 8.23825Z"
        fill="#111111"
      />
      <path
        d="M9.55101 26.8781C9.55101 26.8781 9.47134 27.3451 9.08036 27.4492C8.68937 27.5534 8.65628 27.9604 9.03011 27.9983C9.40393 28.0363 10.2423 27.4113 10.2423 27.4113L10.1197 26.8438L9.55101 26.8781Z"
        fill="#008B07"
      />
      <path
        d="M15.8453 27.008C15.8453 27.008 16.0316 27.4443 16.4361 27.4554C16.8406 27.4664 16.968 27.8525 16.6126 27.9763C16.2572 28.1001 15.2975 27.6895 15.2975 27.6895L15.2889 27.1073L15.8453 27.008Z"
        fill="#008B07"
      />
      <path
        d="M8.31222 1.14905C8.31222 1.14905 8.1823 2.04256 8.29997 2.64926C8.31141 2.7078 8.33428 2.76351 8.36728 2.8132C8.40029 2.86289 8.44277 2.90558 8.4923 2.93882C8.54182 2.97207 8.59742 2.99522 8.65591 3.00694C8.7144 3.01867 8.77462 3.01874 8.83313 3.00715C9.13833 2.94342 9.53054 2.76937 9.65801 2.29872L9.97301 1.52655C10.0197 1.36535 10.0152 1.19363 9.96007 1.03511C9.90496 0.876591 9.80199 0.739098 9.66537 0.641626C9.17877 0.245738 8.3588 0.601179 8.31222 1.14905Z"
        fill="#F4A28C"
      />
      <path d="M9.95977 1.86237L10.5272 4.76717L8.90448 4.9645L9.13736 2.82696L9.95977 1.86237Z" fill="#F4A28C" />
      <path
        d="M10.0976 1.13554L10.0462 2.29379C9.91087 2.33781 9.76448 2.3334 9.63209 2.28129C9.4997 2.22918 9.38956 2.13264 9.32057 2.00821C9.24704 1.88116 9.21226 1.73538 9.22054 1.58881C9.22882 1.44225 9.27978 1.30131 9.36714 1.18334C8.9116 1.22454 8.45378 1.23477 7.99685 1.21398C7.9037 1.20418 7.69657 1.23604 7.70882 0.826674C7.70882 0.826674 7.59361 0.158689 8.06181 0.0287685C8.53002 -0.101151 10.2092 0.199135 10.0976 1.13554Z"
        fill="#111111"
      />
      <path
        d="M7.78295 4.54412C7.78295 4.54412 14.5707 3.24247 16.8908 4.54412C19.211 5.84577 14.3451 17.9516 14.3451 17.9516L7.19463 17.7249C7.19463 17.7249 0.937643 5.78816 7.78295 4.54412Z"
        fill="#008B07"
      />
      <path
        opacity="0.08"
        d="M14.3161 6.21227C14.3161 6.21227 14.6323 9.44311 14.0293 12.674C13.4263 15.9048 10.5276 17.8303 10.5276 17.8303L14.3455 17.9529C14.3455 17.9529 15.8519 13.9719 16.2122 12.6556C16.5725 11.3392 14.3161 6.21227 14.3161 6.21227Z"
        fill="#111111"
      />
      <path
        d="M8.41828 4.43381L11.3378 3.96561L9.13161 13.9241C9.13161 13.9241 7.1387 8.47971 8.41828 4.43381Z"
        fill="white"
      />
      <path
        d="M11.3159 4.06979L12.5256 7.58989L10.8404 8.99695L11.3159 10.7791L9.12811 13.9241C9.12811 13.9241 10.3256 6.40713 11.3159 4.06979Z"
        fill="#008B07"
      />
      <path
        opacity="0.08"
        d="M11.3159 4.06979L12.5256 7.58989L10.8404 8.99695L11.3159 10.7791L9.12811 13.9241C9.12811 13.9241 10.3256 6.40713 11.3159 4.06979Z"
        fill="#111111"
      />
      <path
        d="M8.41986 4.43377L9.0143 3.96557L10.2841 3.5182L10.8418 4.12858L9.24841 4.85417L8.41986 4.43377Z"
        fill="white"
      />
      <path d="M8.80841 4.63113L9.1283 4.18622L9.62959 4.68016L8.98858 5.39104L8.80841 4.63113Z" fill="#111111" />
      <path
        d="M8.9261 5.12753C8.9261 5.12753 8.16619 8.35837 8.38313 11.1627C8.38313 11.1627 8.81457 13.4498 9.12834 13.9241L9.88457 9.70047C9.88457 9.70047 9.27174 6.42428 9.39431 4.78925L8.9261 5.12753Z"
        fill="#111111"
      />
      <path
        d="M17.3516 4.91794C18.9155 6.54072 20.1302 10.4518 18.6765 19.6259L17.044 20.023C17.044 20.023 17.0623 17.0814 16.3086 13.125C15.9637 11.3612 15.4629 9.63154 14.812 7.95636C14.6434 7.51514 14.499 7.06506 14.3794 6.60813C13.9112 4.85666 16.0892 3.60894 17.3516 4.91794Z"
        fill="#008B07"
      />
      <path
        opacity="0.46"
        d="M17.3516 4.91794C18.9155 6.54072 20.1302 10.4518 18.6765 19.6259L17.044 20.023C17.044 20.023 17.0623 17.0814 16.3086 13.125C15.9637 11.3612 15.4629 9.63154 14.812 7.95636C14.6434 7.51514 14.499 7.06506 14.3794 6.60813C13.9112 4.85666 16.0892 3.60894 17.3516 4.91794Z"
        fill="white"
      />
      <path
        d="M7.19556 17.7249L9.12965 26.8916H10.5281L10.2082 21.2535C10.1781 20.7206 10.3233 20.1924 10.6217 19.7497C10.92 19.3071 11.3551 18.9743 11.8604 18.8022L14.3461 17.9565L7.19556 17.7249Z"
        fill="#111111"
      />
      <path
        d="M14.345 17.9516L16.2509 27.1931H14.8904L12.7198 22.0318C12.1763 20.7421 11.1629 19.7072 9.88483 19.1368L14.345 17.9516Z"
        fill="#111111"
      />
      <path
        d="M5.93463 2.89804L6.61364 3.80013C6.61364 3.80013 3.70515 10.4506 2.05664 11.2399C0.408122 12.0292 -2.01501 8.47357 5.93463 2.89804Z"
        fill="#008B07"
      />
      <path
        d="M6.61342 2.59897C6.61342 2.59897 6.94435 1.65644 7.68342 2.13813C8.42249 2.61981 6.61342 3.80012 6.61342 3.80012L6.09619 3.2976L6.61342 2.59897Z"
        fill="#F4A28C"
      />
      <path
        d="M17.5174 19.909C17.5174 19.909 17.0848 20.6015 17.5174 21.0329C17.9501 21.4643 18.7137 21.8835 18.6769 19.6271L17.5174 19.909Z"
        fill="#F4A28C"
      />
      <path d="M21.331 21.4791H14.987V25.0666H21.331V21.4791Z" fill="#707070" />
      <path
        opacity="0.08"
        d="M20.0392 21.4791C20.0392 21.4791 21.1165 24.9428 16.1612 25.0666H21.331V21.4791H20.0392Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M8.4185 4.43379C8.4185 4.43379 6.9808 5.97567 6.6131 7.75288L7.69658 9.13175L6.97835 10.1123C6.97835 10.1123 7.65981 12.6788 9.12816 13.9241C9.12816 13.9241 7.0715 8.54956 8.4185 4.43379Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M9.21938 15.6179C9.38861 15.6179 9.5258 15.4808 9.5258 15.3115C9.5258 15.1423 9.38861 15.0051 9.21938 15.0051C9.05015 15.0051 8.91296 15.1423 8.91296 15.3115C8.91296 15.4808 9.05015 15.6179 9.21938 15.6179Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M9.35799 17.0887C9.52722 17.0887 9.66441 16.9516 9.66441 16.7823C9.66441 16.6131 9.52722 16.4759 9.35799 16.4759C9.18876 16.4759 9.05157 16.6131 9.05157 16.7823C9.05157 16.9516 9.18876 17.0887 9.35799 17.0887Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};

export const OptionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.8462 12C16.8462 13.1046 17.776 14 18.9231 14C20.0701 14 21 13.1046 21 12C21 10.8954 20.0701 10 18.9231 10C17.776 10 16.8462 10.8954 16.8462 12Z"
        fill="#707070"
      />
      <path
        d="M12 14C10.8529 14 9.92308 13.1046 9.92308 12C9.92308 10.8954 10.8529 10 12 10C13.1471 10 14.0769 10.8954 14.0769 12C14.0769 13.1046 13.1471 14 12 14Z"
        fill="#707070"
      />
      <path
        d="M5.07692 14C3.92987 14 3 13.1046 3 12C3 10.8954 3.92987 10 5.07692 10C6.22398 10 7.15385 10.8954 7.15385 12C7.15385 13.1046 6.22398 14 5.07692 14Z"
        fill="#707070"
      />
    </SvgIcon>
  );
};

export const LikeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} style={{ width: "20", height: "20" }} width="20" height="20" viewBox="0 0 20 20">
      <path
        d="M6.24984 3.3335C3.71853 3.3335 1.6665 5.38554 1.6665 7.91683C1.6665 12.5002 7.08317 16.6668 9.99984 17.6361C12.9165 16.6668 18.3332 12.5002 18.3332 7.91683C18.3332 5.38554 16.2811 3.3335 13.7498 3.3335C12.1997 3.3335 10.8293 4.10304 9.99984 5.28091C9.17038 4.10304 7.79996 3.3335 6.24984 3.3335Z"
        fill={props.fill ?? "none"}
        stroke={props.stroke ?? "#111111"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
export const RepostIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_30193_641)">
        <path
          d="M9.16669 1.66675L11.6667 4.16675M11.6667 4.16675L9.16669 6.66675M11.6667 4.16675H5.66669C4.26656 4.16675 3.56649 4.16675 3.03171 4.43923C2.56131 4.67892 2.17885 5.06137 1.93917 5.53177C1.66669 6.06655 1.66669 6.76662 1.66669 8.16675V12.9167C1.66669 13.3038 1.66669 13.4973 1.68807 13.6597C1.83577 14.7816 2.71854 15.6643 3.84037 15.812C4.00283 15.8334 4.19634 15.8334 4.58335 15.8334M8.33335 15.8334H14.3334C15.7335 15.8334 16.4336 15.8334 16.9683 15.5609C17.4387 15.3212 17.8212 14.9388 18.0609 14.4684C18.3334 13.9336 18.3334 13.2335 18.3334 11.8334V7.08341C18.3334 6.6964 18.3334 6.50289 18.312 6.34043C18.1643 5.2186 17.2815 4.33583 16.1597 4.18814C15.9972 4.16675 15.8037 4.16675 15.4167 4.16675M8.33335 15.8334L10.8334 18.3334M8.33335 15.8334L10.8334 13.3334"
          stroke={props.stroke ?? "#111111"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_30193_641">
          <rect width="20" height="20" fill={props.fill ?? "white"} />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const CommentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "19", fill: "none" }}
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M2.83331 1.83325H17.1663C17.7186 1.83325 18.1663 2.28097 18.1663 2.83325V12.0745C18.1661 12.6265 17.7185 13.0745 17.1663 13.0745H12.6243C12.1209 13.0745 11.6267 13.2005 11.1868 13.4407L11.0023 13.55L5.90753 16.8245V14.0842C5.90753 13.5266 5.45543 13.0747 4.89777 13.0745H2.83331C2.28119 13.0745 1.83357 12.6265 1.83331 12.0745V2.83325C1.83331 2.28097 2.28103 1.83325 2.83331 1.83325Z"
        stroke="#111111"
        strokeWidth="2"
      />
    </SvgIcon>
  );
};

export const ShareIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "16", fill: "none" }}
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M11.7052 14.5516L19.1667 7.94981L11.7052 1.34798C11.6988 1.34227 11.6886 1.34685 11.6886 1.35547L11.6886 5.18235C11.6886 5.18809 11.6904 5.193 11.6846 5.19271C11.4599 5.18156 1.78705 4.76008 0.833353 14.842C1.78824 10.204 11.484 10.6958 11.6854 10.7065C11.6907 10.7068 11.6886 10.7109 11.6886 10.7162L11.6886 14.5442C11.6886 14.5528 11.6988 14.5574 11.7052 14.5516Z"
        stroke="#111111"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const PlayIconButton = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "56", height: "56", fill: "none" }}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <rect x="1" y="1" width="54" height="54" rx="27" fill="black" fillOpacity="0.4" />
      <rect x="1" y="1" width="54" height="54" rx="27" stroke="white" strokeWidth="2" />
      <path
        d="M22 28V19.9171L29 23.9585L36 28L29 32.0415L22 36.0829V28Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CommentInteractionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "19", fill: "none" }}
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M2.83325 1.83398H17.1663C17.7185 1.83398 18.1663 2.2817 18.1663 2.83398V12.0752C18.166 12.6273 17.7184 13.0752 17.1663 13.0752H12.6243C12.1208 13.0752 11.6266 13.2013 11.1868 13.4414L11.0022 13.5508L5.90747 16.8252V14.085C5.90747 13.5273 5.45537 13.0754 4.89771 13.0752H2.83325C2.28112 13.0752 1.83351 12.6273 1.83325 12.0752V2.83398C1.83325 2.2817 2.28097 1.83398 2.83325 1.83398Z"
        stroke="#707070"
        strokeWidth="2"
      />
    </SvgIcon>
  );
};

export const PostReportIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <circle cx="6" cy="6" r="5.35" stroke="#707070" strokeWidth="1.3" />
      <path d="M6 5.33301V8.66634" stroke="#707070" strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="6.00016" cy="3.33366" r="0.666667" fill="#707070" />
    </SvgIcon>
  );
};

export const PostUnfollowIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_30247_1081)">
        <path
          d="M10.0002 5.99967L6.00016 9.99967M6.00016 5.99967L10.0002 9.99967M14.6668 7.99967C14.6668 11.6816 11.6821 14.6663 8.00016 14.6663C4.31826 14.6663 1.3335 11.6816 1.3335 7.99967C1.3335 4.31778 4.31826 1.33301 8.00016 1.33301C11.6821 1.33301 14.6668 4.31778 14.6668 7.99967Z"
          stroke="#707070"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_30247_1081">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const PostEditIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "11", height: "12", fill: "none" }}
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
    >
      <path
        d="M8.07009 2.91261L5.82447 0.666992L3.57886 2.91261"
        stroke="#707070"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.82446 0.666992V7.96524"
        stroke="#707070"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33325 5.71973V10.211C1.33325 10.5087 1.45155 10.7943 1.66211 11.0049C1.87268 11.2155 2.15827 11.3338 2.45606 11.3338H9.1929C9.49069 11.3338 9.77628 11.2155 9.98685 11.0049C10.1974 10.7943 10.3157 10.5087 10.3157 10.211V5.71973"
        stroke="#707070"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const PostDeleteIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "14", fill: "none" }}
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
    >
      <path d="M4 1H8" stroke="#707070" strokeWidth="1.3" strokeLinecap="round" />
      <path
        d="M10.5964 3.31738L9.57397 11.501C9.48953 12.1766 8.91497 12.6836 8.23413 12.6836H3.76538C3.08466 12.6835 2.51095 12.1765 2.42651 11.501L1.40308 3.31738H10.5964Z"
        stroke="#707070"
        strokeWidth="1.3"
      />
      <path d="M0.666748 3.33301H11.3334" stroke="#707070" strokeWidth="1.3" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const ShareOnGoalngo = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.49586 1.17972L6.29509 1.38048H0V9.52436C0 9.73908 0.0125483 9.95519 0.0369479 10.1678C0.0606503 10.379 0.0975982 10.5917 0.1457 10.8001C0.232841 11.1801 0.362508 11.5579 0.529819 11.9239L0.586286 12.0473L7.04241 5.59114L7.00128 5.52701C6.79841 5.21052 6.66317 4.86264 6.59973 4.49316L6.56906 4.31401L1.22207 9.6617C1.22067 9.61499 1.21998 9.56968 1.21998 9.52506V2.60046H5.05977L2.59611 5.06413C2.58078 5.07946 2.56404 5.09549 2.54801 5.11083C2.51176 5.14499 2.47621 5.17985 2.44135 5.21889L2.41765 5.24258L2.41416 5.27604C2.41137 5.30044 2.41068 5.32554 2.41068 5.34645C2.40928 5.39804 2.40858 5.45034 2.40789 5.50123C2.4058 5.67621 2.4058 5.85187 2.4058 6.02685C2.4058 6.20183 2.4058 6.37751 2.40789 6.55319L2.40928 6.66613C2.40928 6.70308 2.40998 6.74002 2.41346 6.77696L2.43159 6.97775L6.22328 3.18604C6.23862 3.17071 6.25465 3.15538 6.27138 3.14004C6.30763 3.10588 6.34388 3.07102 6.38014 3.02989L7.35821 2.04276C7.51785 1.88312 7.69771 1.74229 7.89709 1.62169L7.92567 1.60426C8.35999 1.34423 8.85774 1.2069 9.36525 1.2069C10.9129 1.2069 12.1719 2.46592 12.1719 4.01355C12.1719 4.53849 12.0255 5.05088 11.748 5.49634C11.6832 5.603 11.6121 5.70409 11.5431 5.78983L7.76115 9.57246C7.01034 10.3233 6.13265 11.201 6.0741 11.2595C6.05876 11.2749 6.04342 11.2895 6.02739 11.3041C5.99183 11.3376 5.95628 11.3717 5.92142 11.4115L5.89912 11.4352L5.89563 11.4673C5.89284 11.4917 5.89214 11.5161 5.89214 11.5377C5.89075 11.5893 5.89005 11.6415 5.89005 11.6924C5.88796 11.8674 5.88796 12.0431 5.88796 12.2181C5.88796 12.393 5.88796 12.5687 5.89005 12.7437L5.89145 12.8573C5.89145 12.8943 5.89214 12.9312 5.89563 12.9682L5.91376 13.169L8.33977 10.7422V10.7436L10.6989 8.38385V9.52436C10.6989 10.3651 10.4632 11.187 10.0185 11.9002C9.57299 12.614 8.9386 13.1864 8.18291 13.5552L5.95837 14.6434L3.75683 13.567L2.85614 14.467L3.00672 14.5493C3.07016 14.5841 3.1329 14.6183 3.19774 14.6504L5.95767 16L8.71761 14.6504C9.67826 14.1805 10.4848 13.4527 11.0516 12.545C11.6177 11.6381 11.9167 10.5931 11.9167 9.52367V7.16387L12.0471 7.03352C12.0624 7.01818 12.0778 7.00353 12.0938 6.9882C12.1294 6.95473 12.1649 6.92057 12.1963 6.88432L12.2346 6.84181C13.7662 5.26769 13.7516 2.73502 12.1963 1.17902C10.6243 -0.393007 8.06649 -0.393007 6.49446 1.17902L6.49586 1.17972Z"
        fill="#039103"
      />
      <path
        d="M9.06205 6.80901L8.88289 6.77833C8.51341 6.71419 8.16624 6.57895 7.84974 6.37608L7.7856 6.33496L1.95063 12.1699C1.74915 12.361 1.54699 12.5575 1.34831 12.7548L1.14893 12.9542L1.19912 13.0197C1.30648 13.1592 1.4229 13.2958 1.5435 13.4248C1.66829 13.5586 1.80144 13.6876 1.93877 13.8082L2.005 13.8668L2.85341 13.0183V13.0169L9.06135 6.80832L9.06205 6.80901Z"
        fill="#039103"
      />
      <path
        d="M9.01483 4.36186L9.28114 5.22769L9.80607 4.48804L10.7109 4.49989L10.1721 3.77349L10.4656 2.91531L9.6067 3.20601L8.88307 2.66504L8.89214 3.57061L8.15039 4.09346L9.01483 4.36186Z"
        fill="#039103"
      />
    </SvgIcon>
  );
};

export const ShareVia = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "11", height: "12", fill: "none" }}
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
    >
      <path
        d="M8.07033 2.91163L5.82472 0.666016L3.5791 2.91163"
        stroke="#707070"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.82471 0.666016V7.96426"
        stroke="#707070"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.3335 5.71875V10.21C1.3335 10.5078 1.45179 10.7934 1.66236 11.0039C1.87293 11.2145 2.15852 11.3328 2.4563 11.3328H9.19315C9.49093 11.3328 9.77652 11.2145 9.98709 11.0039C10.1977 10.7934 10.316 10.5078 10.316 10.21V5.71875"
        stroke="#707070"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FullScreenCloseButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M18 6L6 18M6 6L18 18" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const FullScreenRightArrowButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const FullScreenLeftArrowButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const CommentOptionButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "22", height: "22", fill: "none" }}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M5.5 12.375C6.25939 12.375 6.875 11.7594 6.875 11C6.875 10.2406 6.25939 9.625 5.5 9.625C4.74061 9.625 4.125 10.2406 4.125 11C4.125 11.7594 4.74061 12.375 5.5 12.375Z"
        fill="#707070"
      />
      <path
        d="M11 12.375C11.7594 12.375 12.375 11.7594 12.375 11C12.375 10.2406 11.7594 9.625 11 9.625C10.2406 9.625 9.625 10.2406 9.625 11C9.625 11.7594 10.2406 12.375 11 12.375Z"
        fill="#707070"
      />
      <path
        d="M16.5 12.375C17.2594 12.375 17.875 11.7594 17.875 11C17.875 10.2406 17.2594 9.625 16.5 9.625C15.7406 9.625 15.125 10.2406 15.125 11C15.125 11.7594 15.7406 12.375 16.5 12.375Z"
        fill="#707070"
      />
    </SvgIcon>
  );
};

export const CommentShowRepliesButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.58861 7.7521C5.9127 7.42845 6.43759 7.42817 6.76202 7.75146L10 10.978L13.238 7.75146C13.5624 7.42817 14.0873 7.42845 14.4114 7.7521C14.7363 8.07661 14.7363 8.60322 14.4114 8.92774L10 13.3332L5.58861 8.92774C5.26366 8.60322 5.26366 8.07661 5.58861 7.7521Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};

export const CommentLikeCountIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.99967 2.66699C2.97463 2.66699 1.33301 4.30863 1.33301 6.33366C1.33301 10.0003 5.66634 13.3337 7.99967 14.1091C10.333 13.3337 14.6663 10.0003 14.6663 6.33366C14.6663 4.30863 13.0247 2.66699 10.9997 2.66699C9.75957 2.66699 8.66324 3.28263 7.99967 4.22493C7.33611 3.28263 6.23977 2.66699 4.99967 2.66699Z"
        fill={props.fill}
      />
      <path
        d="M4.99967 2.66699C2.97463 2.66699 1.33301 4.30863 1.33301 6.33366C1.33301 10.0003 5.66634 13.3337 7.99967 14.1091C10.333 13.3337 14.6663 10.0003 14.6663 6.33366C14.6663 4.30863 13.0247 2.66699 10.9997 2.66699C9.75957 2.66699 8.66324 3.28263 7.99967 4.22493C7.33611 3.28263 6.23977 2.66699 4.99967 2.66699Z"
        stroke="#FF4D4E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CommentReportIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <circle cx="6" cy="6" r="5.35" stroke="#707070" strokeWidth="1.3" />
      <path d="M6 5.33301V8.66634" stroke="#707070" strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="6.00016" cy="3.33366" r="0.666667" fill="#707070" />
    </SvgIcon>
  );
};

export const CommentDeleteIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "14", fill: "none" }}
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
    >
      <path d="M4 1H8" stroke="#707070" strokeWidth="1.3" strokeLinecap="round" />
      <path
        d="M10.5964 3.31738L9.57397 11.501C9.48953 12.1766 8.91497 12.6836 8.23413 12.6836H3.76538C3.08466 12.6835 2.51095 12.1765 2.42651 11.501L1.40308 3.31738H10.5964Z"
        stroke="#707070"
        strokeWidth="1.3"
      />
      <path d="M0.666748 3.33301H11.3334" stroke="#707070" strokeWidth="1.3" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const SortingButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.20711 8.33301C5.76165 8.33301 5.53857 8.87158 5.85355 9.18656L10 13.333L14.1464 9.18656C14.4614 8.87158 14.2383 8.33301 13.7929 8.33301L6.20711 8.33301Z"
        fill={props.fill || "#008B07"}
      />
    </SvgIcon>
  );
};

export const CreatePostFirstStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21", height: "20", fill: "none" }}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M12.4993 9.16699H7.49935M9.16602 12.5003H7.49935M14.166 5.83366H7.49935M17.4993 5.66699V14.3337C17.4993 15.7338 17.4993 16.4339 17.2269 16.9686C16.9872 17.439 16.6047 17.8215 16.1343 18.0612C15.5995 18.3337 14.8995 18.3337 13.4993 18.3337H8.16602C6.76588 18.3337 6.06582 18.3337 5.53104 18.0612C5.06063 17.8215 4.67818 17.439 4.4385 16.9686C4.16602 16.4339 4.16602 15.7338 4.16602 14.3337V5.66699C4.16602 4.26686 4.16602 3.5668 4.4385 3.03202C4.67818 2.56161 5.06063 2.17916 5.53104 1.93948C6.06582 1.66699 6.76588 1.66699 8.16602 1.66699H13.4993C14.8995 1.66699 15.5995 1.66699 16.1343 1.93948C16.6047 2.17916 16.9872 2.56161 17.2269 3.03202C17.4993 3.5668 17.4993 4.26686 17.4993 5.66699Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CreatePostSecondStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21", height: "20", fill: "none" }}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M12.1663 1.8916V5.33372C12.1663 5.80043 12.1663 6.03378 12.2572 6.21204C12.3371 6.36885 12.4645 6.49633 12.6213 6.57622C12.7996 6.66705 13.033 6.66705 13.4997 6.66705H16.9418M7.99967 13.3337L9.66634 15.0003L13.4163 11.2503M12.1663 1.66699H7.83301C6.43288 1.66699 5.73281 1.66699 5.19803 1.93948C4.72763 2.17916 4.34517 2.56161 4.10549 3.03202C3.83301 3.5668 3.83301 4.26686 3.83301 5.66699V14.3337C3.83301 15.7338 3.83301 16.4339 4.10549 16.9686C4.34517 17.439 4.72763 17.8215 5.19803 18.0612C5.73281 18.3337 6.43288 18.3337 7.83301 18.3337H13.1663C14.5665 18.3337 15.2665 18.3337 15.8013 18.0612C16.2717 17.8215 16.6542 17.439 16.8939 16.9686C17.1663 16.4339 17.1663 15.7338 17.1663 14.3337V6.66699L12.1663 1.66699Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CreatePostThirdStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21", height: "20", fill: "none" }}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M17.666 8.33366H2.66602M13.4993 1.66699V5.00033M6.83268 1.66699V5.00033M7.66602 13.3337L9.33268 15.0003L13.0827 11.2503M6.66602 18.3337H13.666C15.0661 18.3337 15.7662 18.3337 16.301 18.0612C16.7714 17.8215 17.1538 17.439 17.3935 16.9686C17.666 16.4339 17.666 15.7338 17.666 14.3337V7.33366C17.666 5.93353 17.666 5.23346 17.3935 4.69868C17.1538 4.22828 16.7714 3.84583 16.301 3.60614C15.7662 3.33366 15.0661 3.33366 13.666 3.33366H6.66602C5.26588 3.33366 4.56582 3.33366 4.03104 3.60614C3.56063 3.84583 3.17818 4.22828 2.9385 4.69868C2.66602 5.23346 2.66602 5.93353 2.66602 7.33366V14.3337C2.66602 15.7338 2.66602 16.4339 2.9385 16.9686C3.17818 17.439 3.56063 17.8215 4.03104 18.0612C4.56582 18.3337 5.26588 18.3337 6.66602 18.3337Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CreatePostArrowBackIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const CreatePostDragAndDropIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "45", height: "44", fill: "none" }}
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
    >
      <g filter="url(#filter0_d_30438_34644)">
        <rect x="2.75" y="1" width="40" height="40" rx="8" fill="white" shape-rendering="crispEdges" />
        <rect x="3.25" y="1.5" width="39" height="39" rx="7.5" stroke="#E4E7EC" shape-rendering="crispEdges" />
        <path
          d="M19.417 24.3333L22.7503 21M22.7503 21L26.0837 24.3333M22.7503 21V28.5M29.417 24.9524C30.4349 24.1117 31.0837 22.8399 31.0837 21.4167C31.0837 18.8854 29.0316 16.8333 26.5003 16.8333C26.3182 16.8333 26.1479 16.7383 26.0554 16.5814C24.9687 14.7374 22.9624 13.5 20.667 13.5C17.2152 13.5 14.417 16.2982 14.417 19.75C14.417 21.4718 15.1132 23.0309 16.2394 24.1613"
          stroke="#475467"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_30438_34644"
          x="0.75"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_30438_34644" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_30438_34644" result="shape" />
        </filter>
      </defs>
    </SvgIcon>
  );
};

export const CreatePostAutocompleteIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21", height: "20", fill: "none" }}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M5.5 7.5L10.5 12.5L15.5 7.5"
        stroke="#707070"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
